import React, { useEffect, useState, useContext } from 'react';
import { Cartcontext } from '../../context/Context';
import './Offer.css';
import offer from '../../image/hot-deal-logo.gif';
import { useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { motion } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function getStockStatus(data) {
    if (data.variation === 'no') {
        return data.quantity > 0 ? 'In-Stock' : 'Out Of Stock';
    } else if (data.variation === 'color') {
        return data.variationData.some((variation) => variation.quantity > 0)
            ? 'In-Stock'
            : 'Out Of Stock';
    } else if (data.variation === 'colorSize') {
        return data.variationData.some((variation) =>
            variation.sizes.some((size) => size.quantity > 0)
        )
            ? 'In-Stock'
            : 'Out Of Stock';
    }
    return 'Out Of Stock';
}

function HotDeal({ data }) {
    const navigate = useNavigate();
    const Globalstate = useContext(Cartcontext);
    const color = Globalstate.color;
    const dispatch = Globalstate.dispatch;

    const [loadingStates, setLoadingStates] = useState([]);

    useEffect(() => {
        if (data && data.length > 0) {
            setLoadingStates(Array(data.length).fill(true));

            data.forEach((item, index) => {
                const img = new Image();
                img.src = item.images[0]?.url || item.imgeUrl;

                if (img.complete) {
                    handleImageLoad(index);
                }
            });
        }
    }, [data]);

    const handleImageLoad = (index) => {
        setLoadingStates((prevState) => {
            const newState = [...prevState];
            newState[index] = false;
            return newState;
        });
    };

    const AddtoCart = (data) => {
        if (
            [
                '6420774a076c3e2bdd58f2ae',
                '64207958076c3e2bdd58f2d9',
                '642b45e176572f46724dfe71',
                '64207fa2076c3e2bdd58f3e8',
            ].includes(data._id)
        ) {
            navigate(`/product-new/64540211e776cdd487628b64`);
            return;
        }

        if (data.productPage === '2') {
            navigate(`/product-new/${data._id}`);
            return;
        }

        if (getStockStatus(data) === 'Out Of Stock') {
            return toast.error('Out Of Stock');
        }
        if (data.variationData.length > 0) {
            return navigate(`/products/${data._id}`);
        }

        const checkoutData = {
            id: data._id,
            title: data.productName,
            colorName: data.color,
            image: data.images[0]?.url || data.imgeUrl,
            price: data.proceSell,
            quantity: 1,
            VariationType: data.variation,
            gid: data._id,
            pCode: data.pCode,
        };

        toast.success('কার্ট-এ অ্যাড হয়েছে', {
            position: 'bottom-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
        dispatch({ type: 'ADD', payload: checkoutData });
    };

    const BuyNow = (data) => {
        if (
            [
                '6420774a076c3e2bdd58f2ae',
                '64207958076c3e2bdd58f2d9',
                '642b45e176572f46724dfe71',
                '64207fa2076c3e2bdd58f3e8',
            ].includes(data._id)
        ) {
            navigate(`/product-new/64540211e776cdd487628b64`);
            return;
        }

        if (data.productPage === '2') {
            navigate(`/product-new/${data._id}`);
            return;
        }

        if (getStockStatus(data) === 'Out Of Stock') {
            return toast.error('Out Of Stock');
        }
        if (data.variationData.length > 0) {
            return navigate(`/products/${data._id}`);
        }

        const checkoutData = {
            id: data._id,
            title: data.productName,
            colorName: data.color,
            image: data.images[0]?.url || data.imgeUrl,
            price: data.proceSell,
            quantity: 1,
            VariationType: data.variation,
            gid: data._id,
            pCode: data.pCode,
        };
        dispatch({ type: 'ADD', payload: checkoutData });
        navigate(`/checkout`);
    };

    return (
        <>
            <ToastContainer />
            {!data && (
                <div className="category-loading">
                    <div className="category-loading-in">
                        <ReactLoading
                            type={'spin'}
                            color={'#333'}
                            height={50}
                            width={50}
                        />
                    </div>
                </div>
            )}

            {data && (
                <div className="Offer-Main">
                    <div className="offer-deal">
                        <img
                            style={{ width: '120px' }}
                            src={offer}
                            alt="Deals"
                            onClick={() => navigate(`/deal-view/HotDeal`)}
                        />
                        <h2
                            onClick={() => navigate(`/deal-view/HotDeal`)}
                        >{`সকল হট ডিল`}</h2>
                    </div>

                    <div className="Offer-Container">
                        {data &&
                            data.map((data, index) => {
                                const title =
                                    data.productName.substring(0, 15) + '...';
                                return (
                                    <motion.div
                                        className="Offer-Product"
                                        key={index}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.7 }}
                                    >
                                        {loadingStates[index] && (
                                            <div className="hot-image-loading">
                                                ছবি লোড হচ্ছে...
                                            </div>
                                        )}
                                        <img
                                            src={
                                                data.images[0]?.url ||
                                                data.imgeUrl
                                            }
                                            alt={data.productName}
                                            onLoad={() =>
                                                handleImageLoad(index)
                                            }
                                            style={{
                                                display: loadingStates[index]
                                                    ? 'none'
                                                    : 'block',
                                            }}
                                            onClick={() => {
                                                if (
                                                    [
                                                        '6420774a076c3e2bdd58f2ae',
                                                        '64207958076c3e2bdd58f2d9',
                                                        '642b45e176572f46724dfe71',
                                                        '64207fa2076c3e2bdd58f3e8',
                                                    ].includes(data._id)
                                                ) {
                                                    navigate(
                                                        `/product-new/64540211e776cdd487628b64`
                                                    );
                                                    return;
                                                }
                                                if (data.productPage === '2') {
                                                    navigate(
                                                        `/product-new/${data._id}`
                                                    );
                                                    return;
                                                }
                                                navigate(
                                                    `/products/${data._id}`
                                                );
                                            }}
                                        />

                                        <div className="sale-out">
                                            {getStockStatus(data)}
                                        </div>
                                        <div className="price-flex">
                                            {data.compare > 0 && (
                                                <p className="price-line">
                                                    ৳ {data.compare}
                                                </p>
                                            )}
                                            <p className="price">
                                                ৳ {data.proceSell}
                                            </p>
                                        </div>

                                        <h2
                                            onClick={() => {
                                                if (
                                                    [
                                                        '6420774a076c3e2bdd58f2ae',
                                                        '64207958076c3e2bdd58f2d9',
                                                        '642b45e176572f46724dfe71',
                                                        '64207fa2076c3e2bdd58f3e8',
                                                    ].includes(data._id)
                                                ) {
                                                    navigate(
                                                        `/product-new/64540211e776cdd487628b64`
                                                    );
                                                    return;
                                                }
                                                if (data.productPage === '2') {
                                                    navigate(
                                                        `/product-new/${data._id}`
                                                    );
                                                    return;
                                                }
                                                navigate(
                                                    `/products/${data._id}`
                                                );
                                            }}
                                        >
                                            {title}
                                        </h2>
                                        <button
                                            style={{
                                                backgroundColor:
                                                    color.AddToCartColor,
                                                color: color.AddToCartTextColor,
                                                marginTop: '5px',
                                                border: 'none',
                                                borderRadius: '3px',
                                                fontSize: '18px',
                                                padding: '4px',
                                                width: '100%',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => AddtoCart(data)}
                                        >
                                            কার্ট-এ যোগ করুন
                                        </button>

                                        {data.showOrderNow &&
                                            data.showOrderNow === 'Yes' && (
                                                <button
                                                    style={{
                                                        backgroundColor:
                                                            color.BuyNowColor,
                                                        color: color.BuyNowTextColor,
                                                        marginTop: '5px',
                                                        border: 'none',
                                                        borderRadius: '3px',
                                                        fontSize: '18px',
                                                        padding: '4px',
                                                        width: '100%',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => BuyNow(data)}
                                                >
                                                    অর্ডার করুন
                                                </button>
                                            )}
                                    </motion.div>
                                );
                            })}
                    </div>
                </div>
            )}
        </>
    );
}

export default HotDeal;
